var SENTRY_RELEASE;SENTRY_RELEASE={name: "Florafolio", version: "0.1.0"};